import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import store, { history } from '@redux/store';
import { PassportContextProvider, PassportEnums } from '@tti/passport';
import { appInsightsReactPlugin } from 'js/appInsights/AppInsightsContext';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import AppRouter from '@js/pages/AppRouter';

const App = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <PassportContextProvider siteID={PassportEnums.Site.ProfileManager}>
        <AppRouter />
      </PassportContextProvider>
    </ConnectedRouter>
  </Provider>
);

export const browserHistory = history;

export default withAITracking(appInsightsReactPlugin, App);
